export default __webpack_public_path__ + "static/media/Selected-facility-icon-big-new.fd2c066b.svg";